export default __webpack_public_path__ + "static/media/Vector.006793c1.svg";